import type { ReactNode } from 'react';

/**
 * The actions that commit or discard a form's edits (Save, Cancel, Discard, Update…) live with the content they act
 * on, one layer below the page header, never in it (Antonin, 15 Oct: "this type of action belongs to the lower level
 * content"). The bar sits under the page's scrolling body, pinned to the bottom of the frame: white, a hairline above,
 * the buttons on the right, 48 from the sides (`--page-pad`), no shadow. The page header keeps page-level actions only.
 */
export function FormActionBar({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <div
      data-slot="form-action-bar"
      title={title}
      className="flex shrink-0 items-center justify-end gap-2 border-t border-[var(--surface-line)] bg-[var(--surface-read)] px-[var(--page-pad)] py-4"
    >
      {children}
    </div>
  );
}
